import { render, staticRenderFns } from "./ModalUpdateVersion.vue?vue&type=template&id=4290f08d"
import script from "./ModalUpdateVersion.vue?vue&type=script&lang=ts"
export * from "./ModalUpdateVersion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports